const Optimization_Timer_Label = {
  queuedLabel: 'Time in queue',
  runTimeLabel: 'Optimization run time'
};

const OTHER_ROUTE_TYPES = {
  EXTRATRLR: 'ExtraTrailerRoute',
  OVERCAPACITY: 'OverCapacityRoute',
  LATEWAVE: 'LateWaveRoute'
};

const OTHER_ROUTES_COMMENTS = {
  [OTHER_ROUTE_TYPES.EXTRATRLR]: 'Extra trailer required',
  [OTHER_ROUTE_TYPES.OVERCAPACITY]: 'Over Capacity'
};

const inputFields = {
  trailerTypeCountList: "trailerTypeCountList",
  maxStopsPerRoute: "maxStopsPerRouteCount",
  lastWaveCutOff: "lastWaveCutOff",
  isReturnToTerminal: "isReturnToTerminal",
  isMergeExtraRoutes: "isMergeExtraRoutes",
  mergedExtraRouteName: "mergedExtraRouteName"
}

export { Optimization_Timer_Label, OTHER_ROUTE_TYPES, OTHER_ROUTES_COMMENTS, inputFields };
